export const getCurrentVersion = () => {
  const releaseVersion = process.env.REACT_APP_RELEASE_VERSION?.trim().replace(
    /^v/,
    '',
  );

  if (/^\d+\.\d+\.\d+(?:[-+][0-9A-Za-z.-]+)?$/.test(releaseVersion ?? '')) {
    return releaseVersion;
  }

  let version = process.env.npm_package_version;

  if (!version) {
    // eslint-disable-next-line
    version = require('../../package.json').version;
  }

  return version ?? null;
};
